// src/components/tableros/common/ConnectionStatus.js
import React from 'react';
import {
  Paper,
  Typography,
  Stack,
  Chip,
  Box,
  Button
} from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

const ConnectionStatus = ({ isConnected, reconnect }) => {
  return (
    <Paper 
      elevation={1} 
      sx={{ 
        p: 2, 
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: isConnected ? 'rgba(46, 125, 50, 0.08)' : 'rgba(211, 47, 47, 0.08)',
        mb: 2
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography variant="body1" color={isConnected ? 'success.main' : 'error.main'}>
          {isConnected ? 'Conectado al servidor de eventos' : 'Desconectado del servidor'}
        </Typography>
        <Chip 
          size="small"
          color={isConnected ? 'success' : 'error'}
          label={isConnected ? 'Online' : 'Offline'}
        />
      </Stack>
      <Box>
        <Button 
          startIcon={<RefreshIcon />}
          variant="outlined"
          color={isConnected ? 'success' : 'error'}
          size="small"
          onClick={reconnect}
          disabled={isConnected}
        >
          {isConnected ? 'Conectado' : 'Reconectar'}
        </Button>
      </Box>
    </Paper>
  );
};

export default ConnectionStatus;